import axios from "axios";
import qs from "qs";
import Validator from "./Validator";

export default class ContactForm {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.selectors = {
      form: "contact-form",
      inputWrapper: "form__input",
      checkboxWrapper: "form__checkbox",
      errorText: "input__error",
      error: "invalid",
      visible: "input__error--visible",
      submit: "submit",
      successPopup: "form__thanks--success",
      errorPopup: "form__thanks--error",
      popupVisible: "form__thanks--visible",
      recapchta: "g-recaptcha-response",
      formHidden: "form-hidden",
      close: "close",
      inputs: [
        "name",
        "company",
        "mail",
        "phone",
        "message",
        "rule-01",
        "rule-02"
      ]
    };

    this.form = document.getElementById(this.selectors.form);

    if (!this.form) return false;

    this.successPopup = document.querySelector(
      `.${this.selectors.successPopup}`
    );
    this.errorPopup = document.querySelector(`.${this.selectors.errorPopup}`);

    this.inputs = [];
    this.initInputs();

    this.validator = new Validator(this.inputs, this.selectors);

    this.submitBtn = document.getElementById(this.selectors.submit);
    this.submitText = this.submitBtn.innerHTML;
    this.recapchta = document.getElementById(this.selectors.recapchta);

    return true;
  }

  initInputs() {
    this.selectors.inputs.forEach(input => {
      this.inputs.push({
        name: input,
        field: document.getElementById(input),
        errors: []
      });
    });
  }

  setupEvents() {
    this.form.addEventListener("submit", e => this.submit(e));

    const successClose = this.successPopup.querySelector(
      `.${this.selectors.close}`
    );

    successClose.addEventListener("click", () => {
      this.successPopup.classList.remove(this.selectors.popupVisible);
    });

    const errorClose = this.errorPopup.querySelector(
      `.${this.selectors.close}`
    );

    errorClose.addEventListener("click", () => {
      this.errorPopup.classList.remove(this.selectors.popupVisible);
    });
  }

  submit(e) {
    e.preventDefault();
    if (!this.recapchta) {
      this.recapchta = document.getElementById(this.selectors.recapchta);
    }

    if (!this.validator.validate() || !this.recapchta || !this.recapchta.value)
      return false;

    const data = this.buildData();
    this.post(data);
  }

  disableSubmit() {
    this.submitBtn.disabled = true;
  }

  enableSubmit() {
    this.submitBtn.disabled = false;
  }

  buildData() {
    const data = { action: "sendContactForm" };
    this.inputs.forEach(input => {
      if (input.name === "rule-01" || input.name === "rule-02") {
        data[input.name] = input.field.checked;
      } else {
        data[input.name] = input.field.value;
      }
    });

    data["recapchta"] = this.recapchta.value;
    const pageId = document.getElementById("hidden").value;
    data["page"] = pageId;
    return data;
  }

  post(data) {
    this.disableSubmit();
    axios
      .post(ajaxurl, qs.stringify(data))
      .then(response => {
        this.form.classList.add(this.selectors.formHidden);
        if (response.data.success === true) {
          this.form.reset();
          this.enableSubmit();
          this.successPopup.classList.add(this.selectors.popupVisible);
        } else {
          throw "recapchta error";
        }
      })
      .catch(error => {
        this.enableSubmit();
        this.errorPopup.classList.add(this.selectors.popupVisible);
      });
  }
}
